import requests from './httpService';
const adminInfo = localStorage.getItem("adminInfo")
  ? JSON.parse(localStorage.getItem("adminInfo"))
  : null;
const id_employee = adminInfo?.id ? adminInfo.id : 0;
const NotificationServices = {
  addNotification: async (body) => {
    return requests.post('/notification/add', body);
  },

  getAllNotification: async () => {
    return requests.get(`/notification/getAllNotification/${id_employee}`);
  },

  updateStatus: async (id, body) => {
    return requests.put(`/notification/${id}`, body);
  },

  deleteNotification: async (id, body) => {
    return requests.put(`/notification/update/${id}`,body);
  },
};

export default NotificationServices;
